var map = {
	"./blog_en.json": "9c28",
	"./blog_it.json": "9288",
	"./cookie_policy_en.json": "f5ed",
	"./cookie_policy_it.json": "6664",
	"./crm_faq_en.json": "900a",
	"./crm_faq_it.json": "cf6e",
	"./en.json": "edd4",
	"./how_it_work_also_includes_en.json": "856d",
	"./how_it_work_also_includes_it.json": "9139",
	"./it.json": "0825",
	"./privacy_policy_en.json": "7f8a",
	"./privacy_policy_it.json": "ad28",
	"./technical_analysis_faq_en.json": "9630",
	"./technical_analysis_faq_it.json": "7205",
	"./terms_of_service_en.json": "6078",
	"./terms_of_service_it.json": "bf1a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";